export default __webpack_public_path__ + "images/PS.4c2fb3c.png";